//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'NaCorrection_Albumen',
  data() {
    return {
      form:{
        na:'',
        pr:'',
      },
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        console.log(form)
        // Na校正值=Na（mmol/L）+0.025* Pr（g/L）
        let result = form.na +0.025 * form.pr
        self.hasScore = true
        return String(result.toFixed(0))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Renal/NaCorrection_Albumen.vue